import { writable } from "svelte/store";

export type ToastType = "success" | "error" | "info";

export interface ToastInput {
  message: string;
  type?: ToastType;
  dismissible?: boolean;
  timeout?: number;
}

interface ToastDefaults {
  id: number;
  type: ToastType;
  dismissible: boolean;
  timeout: number;
}

export interface ToastItem extends ToastDefaults {
  message: string;
}

export const toasts = writable<ToastItem[]>([]);
let toastCounter = 0;

const nextToastId = (): number => {
  toastCounter += 1;
  return Date.now() + toastCounter;
};

export const dismissToast = (id: number): void => {
  toasts.update((all) => all.filter((t) => t.id !== id));
};

export const addToast = (toast: ToastInput): number => {
  const id = nextToastId();

  const defaults: ToastDefaults = {
    id,
    type: "info",
    dismissible: true,
    timeout: 3000,
  };

  const nextToast: ToastItem = { ...defaults, ...toast };
  toasts.update((all) => [nextToast, ...all]);

  if (nextToast.timeout > 0) {
    setTimeout(() => {
      dismissToast(id);
    }, nextToast.timeout);
  }

  return id;
};
